<template>
  <c-container fluid class="d-flex content-center min-vh-100 login-container c-app c-dark-theme">
    <img class="logo" src="/img/logos/longboss.png" alt="KoalaBoss logo" />
    <c-row class="container">
      <c-col sm="12" md="6">
        <c-card-group>
          <c-card class="p-4 login-form">
            <c-card-body>
              <c-form @submit.prevent="createAccount">
                <h1 class="h1">Get Started</h1>
                <p class="lead">Simply enter your email and password.</p>
                <c-alert show color="warning" v-if="error" close-button class="mt-4">
                  {{ error }}
                </c-alert>
                <div class="login-fields">
                  <c-input
                    v-model="data.body.username"
                    placeholder="Your email address"
                    autocomplete="off"
                    :disabled="isCreatingAccount"
                  >
                    <template #prepend-content><c-icon name="cil-user" /></template>
                  </c-input>
                  <c-input
                    placeholder="Your password"
                    v-model="data.body.password"
                    type="password"
                    autocomplete="off"
                    :disabled="isCreatingAccount"
                  >
                    <template #prepend-content><c-icon name="cil-lock-locked" /></template>
                  </c-input>
                </div>
                <c-row class="my-4">
                  <CCol sm="12">
                    <CSwitch
                        id="acceptTerms"
                        class="float-left pt-1"
                        color="success"
                        :checked="false"
                        shape="pill"
                        @update:checked="handleAcceptTerms"
                    />
                    <p class="text-left pl-5 pt-0">By activating your account you accept the KoalaBoss <a href="https://koalaboss.com/terms-of-use/" class="color-kb-green" target="_blank">terms of use</a>.</p>
                  </CCol>
                </c-row>
                <c-row class="mt-4">
                  <c-col col="12" class="text-center">
                    <c-button type="submit" color="primary btn-login" class="px-4 w-100" :disabled="!acceptTerms">
                      <CSpinner v-if="isCreatingAccount" color="success" size="sm"/>
                      <span v-else>Create Account</span>
                    </c-button>
                  </c-col>
                </c-row>
              </c-form>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
      <c-col sm="12" md="6">
        <h2 class="mb-4">{{ firstSite }}</h2>
        <template v-if="gettingScreenshot">
<!--          <screenshot-loader />-->
          <modern-monitor screenshot-url="/img/gifs/screenshot-loader.gif" size="loader"/>
        </template>
        <template v-else>
          <modern-monitor :screenshot-url="screenshotUrl" size="large"/>
        </template>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
import _ from 'lodash';
import ScreenshotLoader from '@/views/components/screenshot-loader';
import ModernMonitor from '@/views/components/plugin-install/ModernMonitor.vue';

export default {
  name: 'GetStarted',
  components: {
    ScreenshotLoader,
    ModernMonitor,
  },
  data() {
    return {
      gettingScreenshot: false,
      isLoggingIn: false,
      isCreatingAccount: false,
      error: null,
      screenshotUrl: '',
      data: {
        body: {
          username: null,
          password: null,
        },
      },
      acceptTerms: false,
    };
  },

  computed: {
    firstSite() {
      return this.$route.query.url;
    },
  },

  mounted() {
    this.getScreenshot();
  },
  methods: {
    handleAcceptTerms(e) {
      this.acceptTerms = e;
    },
    getScreenshot() {
      this.gettingScreenshot = true;
      this.$http
        .get(`${process.env.VUE_APP_KOALABOSS_SCREENSHOT_API}/screenshot/url/desktop?url=${this.firstSite}`)
        .then((response) => {
          this.gettingScreenshot = false;
          if (!response.data.success) {
            this.error = response.data.message;
          }
          this.screenshotUrl = _.get(response, 'data.data.s3ImageUrl');
        })
        .catch((error) => {
          this.error = error.response.data.message;
          this.gettingScreenshot = false;
        });
    },
    createAccount() {
      if (!this.data.body.username || !this.data.body.password || !this.firstSite) {
        return;
      }
      // Get rid of surrounding spaces
      this.data.body.username = _.trim(this.data.body.username);
      this.data.body.password = _.trim(this.data.body.password);
      const data = {
        username: this.data.body.username,
        password: this.data.body.password,
        url: this.firstSite,
        screenshotUrl: this.screenshotUrl,
      };
      this.isCreatingAccount = true;
      this.$http
        .post(`${process.env.VUE_APP_KOALABOSS_API}/get-started/create-account`, data)
        .then((response) => {
          this.isCreatingAccount = false;
          if (!response.data.success) {
            this.error = response.data.message;
            return;
          }
          // Login
          this.login();
        })
        .catch((error) => {
          this.error = error.response.data.message;
          this.isCreatingAccount = false;
        });
    },
    login() {
      if (!this.data.body.username) {
        return;
      }
      if (!this.data.body.password) {
        return;
      }
      this.isLoggingIn = true;

      // Get rid of surrounding spaces
      this.data.body.username = _.trim(this.data.body.username);
      this.data.body.password = _.trim(this.data.body.password);

      setTimeout(() => {
        this.$auth.login({
          headers: {
            'Content-Type': 'application/json',
          },
          data: this.data.body,
          rememberMe: false,
          redirect: { name: 'dashboard', query: { refresh: '1' } },
          success() {
            // Do nothing
          },
          error(err) {
            this.isLoggingIn = false;
            if (err.response) {
              // The request was made, but the server responded with a status code
              // that falls out of the range of 2xx
              this.error = err.response.data.message;
            } else {
              // Something happened in setting up the request that triggered an Error
              this.error = 'There was an error logging into KoalaBoss, please try again.';
            }
          },
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss"></style>
